import type { PaymentMethod } from '@openeducation/pp-rn-shared-types';
import { atom } from 'jotai';

export const selectedPaymentMethodAtom = atom<PaymentMethod>(
  '' as PaymentMethod
);
